module.exports = __webpack_public_path__ + "static/media/gtff-icon.abebb749.svg";